import { IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import getFileName from "../../../../function/getFileName";
import getFileSize, {
  getFormattedFileSize,
} from "../../../../function/getFileSize";
import BootstrapTooltip from "../../../atoms/bootstrapTooltip/bootstrapTooltip";
import FA__ImageIcon from "../../../../assets/icons/image-light-full.svg";
import FA__CloseIcon from "../../../../assets/icons/xmark-regular-full.svg";
import SvgIcon from "../../../atoms/icons/svgIcon/svgIcon";

const RenderFilesForUpload = (): React.JSX.Element => {
  const {
    chatInput,
    setChatInput,
  }: {
    chatInput: IMessage;
    setChatInput: React.Dispatch<React.SetStateAction<IMessage>>;
  } = React.useContext(AppContext);

  if (chatInput.content === null) return <></>;

  const uploadFileName: string = getFileName(chatInput.content);
  const uploadFileSize: string = getFormattedFileSize(
    getFileSize(chatInput.content),
  );

  return (
    <Grid
      container
      role="status" // A11Y FIX
      aria-live="polite" // A11Y FIX
      aria-label={`Datei ausgewählt: ${uploadFileName}, ${uploadFileSize}`} // A11Y FIX
      spacing={2}
      sx={{
        color: (theme) => theme.palette.primary.main,
        fontSize: "0.75rem",
        fontWeight: "bold",
        px: 1,
        py: 1,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Grid
        size={{ xs: 2 }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SvgIcon sizeInPx="36" icon={FA__ImageIcon} />
      </Grid>

      <Grid size={{ xs: 8 }} container spacing={0}>
        <Grid
          size={{ xs: 12 }}
          sx={{
            wordBreak: "break-all",
            textAlign: "left",
          }}
        >
          <Typography variant="body2" color="initial">
            {uploadFileName}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography variant="caption" color="initial">
            {uploadFileSize}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        size={{ xs: 2 }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BootstrapTooltip
          title="Datei entfernen"
          placement="left"
          children={
            <IconButton
              aria-label={`Datei ${uploadFileName} entfernen`} // A11Y FIX
              onClick={() => {
                setChatInput({ ...chatInput, content: null });
              }}
            >
              <SvgIcon icon={FA__CloseIcon} />
            </IconButton>
          }
          arrow={false}
        />
      </Grid>
    </Grid>
  );
};

export default RenderFilesForUpload;
